import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Icon from "../AppIcon";

const LABEL_MAP = {
  apartmani: { label: "Apartments", icon: "Building" },
  sobe: { label: "Rooms", icon: "Bed" },
  contact: { label: "Contact", icon: "MessageCircle" },
  gallery: { label: "Gallery", icon: "Images" },
};

const Breadcrumb = ({ customItems = null, title = null }) => {
  const location = useLocation();
  const navigate = useNavigate();

  if (customItems) {
    return (
      <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
        {customItems.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && (
              <Icon name="ChevronRight" size={14} className="text-border" />
            )}
            <button
              onClick={() => item.path && navigate(item.path)}
              disabled={!item.path || item.isActive}
              className={`flex items-center space-x-1 ${
                item.isActive
                  ? "text-foreground font-medium cursor-default"
                  : "hover:text-foreground"
              }`}
            >
              {item.icon && <Icon name={item.icon} size={14} />}
              <span>{item.label}</span>
            </button>
          </React.Fragment>
        ))}
      </nav>
    );
  }

  const segments = location.pathname.split("/").filter(Boolean);

  // Home only → no breadcrumb
  if (segments.length === 0) return null;

  const breadcrumbs = [{ label: "Home", path: "/", icon: "Home" }];

  // First segment: apartmani / sobe
  const first = segments[0];
  if (LABEL_MAP[first]) {
    breadcrumbs.push({
      label: LABEL_MAP[first].label,
      icon: LABEL_MAP[first].icon,
      path: `/${first}`,
    });
  }

  // Slug (detail page)
  if (segments.length > 1) {
    breadcrumbs.push({
      label: title || segments[1].replace(/-/g, " "),
      isActive: true,
    });
  } else {
    breadcrumbs[breadcrumbs.length - 1].isActive = true;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      {breadcrumbs.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-border" />
          )}
          <button
            onClick={() => item.path && navigate(item.path)}
            disabled={item.isActive || !item.path}
            className={`flex items-center space-x-1 transition-smooth ${
              item.isActive
                ? "text-foreground font-medium cursor-default"
                : "hover:text-foreground"
            }`}
          >
            {item.icon && <Icon name={item.icon} size={14} />}
            <span className="capitalize">{item.label}</span>
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
